import axios from 'axios'
import env from './env'

const base: string = process.env.REACT_APP_API_ENDPOINT || env.apiBaseUrl
const storageBase: string = process.env.REACT_APP_STORAGE || env.storageBaseUrl
const deliveryBase: string = env.deliveryApiBaseUrl

const ws = axios.create({
    baseURL: base,
    timeout: 60000,
    withCredentials: true,
    headers: {}
})

const storageHttpClient = axios.create({
    baseURL: storageBase,
    timeout: 10000,
    headers: { 'Cache-Control': 'no-store' }
})

const deliveryClient = axios.create({
    baseURL: deliveryBase,
    timeout: 60000,
    headers: {}
})

export { ws, storageHttpClient, deliveryClient }
